// @ts-nocheck

/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

function useGtag(verifyAppStoreConnection?: boolean) {
  const API_ENDPOINT =
    process.env.NODE_ENV === "development"
      ? "http://localhost:9001/verify-app-store-connection"
      : "https://admin.panoroom.app/verify-app-store-connection";

  React.useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag("js", new Date());

    gtag("config", "G-PSWHZL7CC5");

    gtag("consent", "update", {
      ad_user_data: "granted",
      ad_personalization: "granted",
      ad_storage: "granted",
      analytics_storage: "granted",
    });

    if (verifyAppStoreConnection) {
      const eventsDone = new Promise((res) => {
        gtag("event", "app_store_download_visited", {
          event_callback: function() {
            res();
          },
        });
      });

      gtag("get", "G-PSWHZL7CC5", "session_id", (session_id) => {
        gtag("get", "G-PSWHZL7CC5", "client_id", (client_id) => {
          console.log({ client_id, session_id });
          fetch(API_ENDPOINT, {
            method: "POST",
            body: JSON.stringify({ client_id, session_id, original_url: window.location + "" }),
            headers: { "Content-Type": "application/json" },
          })
            .then((res) => res.json())
            .then(async ({ redirect }) => {
              await eventsDone;
              if (redirect) window.location = redirect;
            });
        });
      });
    }
  }, []);
}

function SEO({
  description,
  title,
  verifyAppStoreConnection,
}: {
  description?: string;
  title: string;
  verifyAppStoreConnection?: boolean;
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            keywords
          }
        }
      }
    `
  );

  useGtag(verifyAppStoreConnection);

  const metaDescription = description || site.siteMetadata.description;

  return (
    <>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-PSWHZL7CC5"
      />

      {/* @ts-ignore */}
      <Helmet
        htmlAttributes={{}}
        title={title}
        titleTemplate={`%s | ${site.siteMetadata.title}`}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            name: "keywords",
            content: site.siteMetadata.keywords.join(","),
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ]}
      />
    </>
  );
}

export default SEO;
